import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import appConfig from '../../../app-config';
import { cognitoConfirmPassword } from '../../../authentication/cognito';
import { ButtonType, ButtonVariant, FeedbackType, FormControlType, PasswordPeeker, Variant } from '../..';
import * as formik from 'formik';
import * as yup from 'yup';

import '../login.scss';

export default function ResetPassword({ onNotifyEvent, onSwitchToLogin }) {

  const [submitButtonEnabled, setSubmitButtonEnabled] = useState(true);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const handleSwitchToLogin = (e) => {
    onSwitchToLogin(e);
  }

  const handleResetPasswordClick = (e) => {
    setSubmitButtonEnabled(false);
    cognitoConfirmPassword(e.email, e.validationCode, e.password).then((result) => {
      onSwitchToLogin(e);

      onNotifyEvent({
        email: e.email,
        notificationTitle: 'Success',
        notificationMessage: result,
        notificationType: Variant.SUCCESS,
      });
    }).catch((error) => {
      setSubmitButtonEnabled(true);

      onNotifyEvent({
        notificationTitle: 'Error',
        notificationMessage: error,
        notificationType: Variant.DANGER,
      });
    });
  }

  const onPasswordPeekerChanged = (e) => {
    setPasswordVisible(e.passwordVisible);
  }

  const onConfirmPasswordPeekerChanged = (e) => {
    setConfirmPasswordVisible(e.passwordVisible);
  }

  const { Formik } = formik;

  const schema = yup.object().shape({
    email: yup.string().matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$/i, 'Invalid email format').required('Email address is required'),
    validationCode: yup.string().required('Validation code required'),
    password: yup.string().min(6, 'Password must be at least 6 characters').required('Password is required'),
    confirmPassword: yup.string().required('Confirm password required').oneOf([yup.ref('password')], 'Passwords must match'),
  });

  const initialValues = {
    email: '',
    validationCode: '',
    password: '',
    confirmPassword: '',
  }

  return (
    <div>
      <div className={'app-login-header'}>
        <div className={'app-title'}>{appConfig.app.title}</div>
        <div>{'Reset your password'}</div>
      </div>

      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        onSubmit={handleResetPasswordClick}
      >

        {({ handleSubmit, handleChange, values, touched, errors }) => (
          <Form noValidate onSubmit={handleSubmit}>

            <Row>
              <Form.Group as={Col} size='sm'>
                <FloatingLabel
                  label='Email address'
                  className='mb-3'
                >
                  <Form.Control
                    type={FormControlType.EMAIL}
                    name='email'
                    placeholder='name@example.com'
                    value={values.email}
                    onChange={handleChange}
                    isValid={touched.email && !errors.email}
                    isInvalid={touched.email && !!errors.email}
                  />
                  <Form.Control.Feedback></Form.Control.Feedback>
                  <Form.Control.Feedback type={FeedbackType.INVALID}>{errors.email}</Form.Control.Feedback>
                </FloatingLabel>
              </Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col} size='sm'>
                <FloatingLabel
                  label='Validation Code'
                  className='mb-3'
                >
                  <Form.Control
                    ttype={FormControlType.TEXT}
                    name='validationCode'
                    placeholder='Validation Code'
                    value={values.validationCode}
                    onChange={handleChange}
                    isValid={touched.validationCode && !errors.passwvalidationCodeord}
                    isInvalid={touched.validationCode && !!errors.validationCode}
                  />
                  <Form.Control.Feedback></Form.Control.Feedback>
                  <Form.Control.Feedback type={FeedbackType.INVALID}>{errors.validationCode}</Form.Control.Feedback>
                </FloatingLabel>
              </Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col} size='sm'>
                <FloatingLabel
                  label='Password'
                  className='mb-3'
                >
                  <Form.Control
                    type={passwordVisible ? FormControlType.TEXT : FormControlType.PASSWORD}
                    className='app-password-input-box'
                    name='password'
                    placeholder='Password'
                    value={values.password}
                    onChange={handleChange}
                    isValid={touched.email && !errors.password}
                    isInvalid={touched.email && !!errors.password}
                  />
                  <PasswordPeeker onChange={onPasswordPeekerChanged} passwordVisible={passwordVisible} />
                  <Form.Control.Feedback></Form.Control.Feedback>
                  <Form.Control.Feedback type={FeedbackType.INVALID}>{errors.password}</Form.Control.Feedback>
                </FloatingLabel>
              </Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col} size='sm'>
                <FloatingLabel
                  label='Confirm password'
                  className='mb-3'
                >
                  <Form.Control
                    type={confirmPasswordVisible ? FormControlType.TEXT : FormControlType.PASSWORD}
                    className='app-password-input-box'
                    name='confirmPassword'
                    placeholder='Confirm password'
                    value={values.confirmPassword}
                    onChange={handleChange}
                    isValid={touched.email && !errors.confirmPassword}
                    isInvalid={touched.email && !!errors.confirmPassword}
                  />
                  <PasswordPeeker onChange={onConfirmPasswordPeekerChanged} passwordVisible={confirmPasswordVisible} />
                  <Form.Control.Feedback></Form.Control.Feedback>
                  <Form.Control.Feedback type={FeedbackType.INVALID}>{errors.confirmPassword}</Form.Control.Feedback>
                </FloatingLabel>
              </Form.Group>
            </Row>

            <Row className='app-form-button-row'>
              <Button
                variant={ButtonVariant.SUCCESS}
                type={ButtonType.SUBMIT}
                disabled={!submitButtonEnabled}
              >
                Reset Password
              </Button>
            </Row>

            <Row className='app-form-button-link-row'>
              <span>Return to
                <Button
                  className='app-button-link'
                  variant={ButtonVariant.LINK}
                  onClick={handleSwitchToLogin}>
                  Login
                </Button>
              </span>
            </Row>
          </Form>
        )}

      </Formik>

    </div>
  );
}